import { render, staticRenderFns } from "./HomeMar.vue?vue&type=template&id=42237d18&"
import script from "./HomeMar.vue?vue&type=script&lang=js&"
export * from "./HomeMar.vue?vue&type=script&lang=js&"
import style0 from "./HomeMar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports